import { useRouter } from 'next/router'

export function isInsideWorkspace() {
  return !!useRouter().query.workspaceId
}
